import React, { useContext, useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo/logo-full.png";
import bg6 from "../../assets/images/background/bg6.jpg";
import { loginUser } from "../../api/auth";
import { AuthContext, useAuth } from "../../context/AuthContext";
// import { login } from "../../services/AuthService";
function Login(props) {
  const [heartActive, setHeartActive] = useState(true);

  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [email, setEmail] = useState("");
  let errorsObj = { email: "", password: "" };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // const dispatch = useDispatch();

  async function onLogin(e) {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };
    if (email === "") {
      errorObj.email = "Email is Required";
      error = true;
    }
    if (password === "") {
      errorObj.password = "Password is Required";
      error = true;
    }
    setErrors(errorObj);
    if (error) {
      return;
    }

    const loginData = {
      email: email,
      password: password,
    };
    try {
      const response = await loginUser(loginData);
      console.log("res======>>>>", response);

      if (response && response.access_token) {
        const userData = response.user;
        setUser(userData);
        navigate("/dashboard");
      } else {
        setErrors({ api: "Login failed. Token not received." });
      }
    } catch (err) {
      console.error("Login error:", err);
      setErrors({ api: err.message || "Login failed." });
    }

    // dispatch(loadingToggleAction(true));
    // dispatch(loginAction(email, password, navigate));
  }

  return (
    <div className="page-wraper">
      <div className="browse-job login-style3">
        <div
          className="bg-img-fix overflow-hidden"
          style={{ background: "#090b22", height: "100vh" }}
        >
          <div
            className="col-xl-4 col-lg-5 col-md-6 col-sm-12 bg-white"
            style={{
              justifySelf: "center",
              borderRadius: "2rem",
            }}
          >
            <div
              id="mCSB_1"
              className="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside"
              style={{ maxHeight: "653px" }}
            >
              <div
                id="mCSB_1_container"
                className="mCSB_container"
                style={{
                  position: "relative",
                  top: "0",
                  left: "0",
                  dir: "ltr",
                }}
              >
                <div className="login-form style-2">
                  <div className="card-body">
                    <div className="logo-header">
                      <Link to={"#"} className="logo">
                        <img
                          src={logo}
                          alt=""
                          className="width-230 mCS_img_loaded"
                        />
                      </Link>
                    </div>
                    <div className="nav nav-tabs border-bottom-0">
                      <div className="tab-content w-100" id="nav-tabContent">
                        <div
                          className="tab-pane fade active show"
                          id="nav-personal"
                        >
                          {props.errorMessage && (
                            <div className="bg-red-300 text-red-900 border border-red-900 p-1 my-2">
                              {props.errorMessage}
                            </div>
                          )}
                          {props.successMessage && (
                            <div className="bg-green-300 text-green-900 border border-green-900 p-1 my-2">
                              {props.successMessage}
                            </div>
                          )}
                          <form className=" dz-form pb-3" onSubmit={onLogin}>
                            <h3 className="form-title m-t0">
                              Personal Information
                            </h3>
                            <div className="dz-separator-outer m-b5">
                              <div className="dz-separator bg-primary style-liner"></div>
                            </div>
                            <p>Enter your e-mail address and your password. </p>
                            <div className="form-group mb-3">
                              <input
                                type="email"
                                className="form-control"
                                value={email}
                                placeholder="Please Enter e-Mail Address"
                                onChange={(e) => setEmail(e.target.value)}
                              />
                              {errors.email && (
                                <div className="text-danger fs-12">
                                  {errors.email}
                                </div>
                              )}
                            </div>
                            <div className="form-group mb-3 position-relative">
                              <input
                                type={showPassword ? "text" : "password"}
                                className="form-control pe-5"
                                value={password}
                                placeholder="Please Enter Password"
                                onChange={(e) => setPassword(e.target.value)}
                              />
                              <i
                                className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"} position-absolute`}
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                  right: "15px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  cursor: "pointer",
                                  fontSize: "1.2rem",
                                }}
                              ></i>

                              {errors.password && (
                                <div className="text-danger fs-12">{errors.password}</div>
                              )}
                            </div>

                            <div className="form-group text-left mb-5">
                              <button
                                type="submit"
                                className="btn btn-primary dz-xs-flex m-r5"
                              >
                                login
                              </button>
                            </div>
                            {/* <div className="dz-social">
                                <h5 className="form-title fs-20">
                                  Sign In With
                                </h5>
                                <ul className="dz-social-icon dz-border dz-social-icon-lg text-white">
                                  <li>
                                    <Link
                                      target="_blank"
                                      to="https://www.facebook.com/"
                                      className="fab fa-facebook-f btn-facebook"
                                    ></Link>
                                  </li>
                                  <li>
                                    <Link
                                      target="_blank"
                                      to="https://www.google.com/"
                                      className="fab fa-google-plus-g btn-google-plus"
                                    ></Link>
                                  </li>
                                  <li>
                                    <Link
                                      target="_blank"
                                      to="https://www.linkedin.com/"
                                      className="fab fa-linkedin-in btn-linkedin"
                                    ></Link>
                                  </li>
                                  <li>
                                    <Link
                                      target="_blank"
                                      to="https://twitter.com/"
                                      className="fab fa-twitter btn-twitter"
                                    ></Link>
                                  </li>
                                </ul>
                              </div> */}
                          </form>
                          <div className="text-center bottom">
                            <NavLink
                              to="/page-register"
                              className="btn btn-primary button-md btn-block"
                            >
                              Create an account
                            </NavLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className=" bottom-footer clearfix m-t10 m-b20 row text-center">
                      <div className="col-lg-12 text-center">
                        <span>
                          {" "}
                          © Copyright by{" "}
                          <span
                            className={`heart ${heartActive ? "" : "heart-blast"
                              }`}
                            onClick={() => setHeartActive(!heartActive)}
                          ></span>
                          <a href="/" target="_blank" rel="noreferrer">
                            PINANCE
                          </a>{" "}
                          All rights reserved.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
